module.exports = __webpack_public_path__ + "media/images/placeholder-jobs-674ca0bf.png";